module.exports = __webpack_public_path__ + "img/cr3.4e4f3023.png";